export var getTextFromForgeDocChildren = function getTextFromForgeDocChildren(forgeDoc) {
  return forgeDoc.children.map(function (child) {
    var _child$props;
    if (child !== null && child !== void 0 && (_child$props = child.props) !== null && _child$props !== void 0 && _child$props.text) {
      var _child$props2;
      return (_child$props2 = child.props) === null || _child$props2 === void 0 ? void 0 : _child$props2.text;
    } else {
      return '';
    }
  });
};